<div class="modal-header ">
  <h4>
    {{'Create Payment'|translate}}</h4>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="col-md-12">
  <table class="table table-striped tableBodyScroll" *ngIf="!!array?.length">
    <thead>
      <tr>
        <th>Pending Invoices </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of array,let i=index;">
        <td>{{data.prefix}}{{data.invoiceNo}}</td>
      </tr>
    </tbody>
  </table>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-sm-6" *ngIf="!!amountDue">
      <div class="mb-3 ">
        <label class="text-danger" for="large-rounded-input">{{'Due'|translate}} {{'Amount'|translate}}: {{ amountDue
          }}</label>
      </div>
    </div>
    <div class="col-sm-6" *ngIf="!!multiDueAmount">
      <div class="mb-3 ">
        <label class="text-danger" for="large-rounded-input">{{'Due'|translate}} {{'Amount'|translate}}: {{
          multiDueAmount }}</label>
      </div>
    </div>
    <div class="col-sm-6" *ngIf="!!data?.vendorName">
      <div class="mb-3 ">
        <label class="text-danger" for="large-rounded-input">{{'Vendor'|translate}} {{'Name'|translate}}: {{
          data.vendorName }}</label>
      </div>
    </div>
  </div>  
  <div class="row">
    <div class="col-sm-6">
      <div class="mb-3 " [ngClass]="{ 'has-danger' : (submitted && !paymentData.transactionType) }">
        <label class="text-muted" for="large-rounded-input">Payment {{'Method'|translate}}</label>
        <select class="form-control" [(ngModel)]="paymentData.transactionType"
          (ngModelChange)="changeTransactionType($event)">
          <option value="CASH">CASH</option>
          <option value="CHEQUE">CHEQUE</option>
          <option value="POS">CARD</option>
          <option value="QRCODE">{{'QRCODE'|translate}}</option>
          <option value="NETBANKING">{{'NETBANKING'|translate}}</option>
          <option value="MO">{{'MO'|translate}}</option>
        </select>
        <small class="text-danger" *ngIf="submitted && !paymentData.transactionType">
          {{'Transaction'|translate}} type {{'is required'|translate}}
        </small>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="mb-3 " *ngIf="!array.length"
        [ngClass]="{ 'has-danger' : (submitted && !paymentData.paidAmount) || !!message}">
        <label class="text-muted" for="large-rounded-input">{{'Due'|translate}} {{'Amount'|translate}}</label>
        <input type="text" class="form-control" [(ngModel)]="paymentData.paidAmount"
          (keyup)="checkPaidAmount($event.target.value)">
        <small class="text-danger" *ngIf="submitted && !paymentData.paidAmount">
          {{'Due'|translate}} amount {{'is required'|translate}}
        </small>
        <small class="text-danger" *ngIf="!!message ">
          {{message}}
        </small>
      </div>
      <div class="mb-3 " *ngIf="!!array.length"
        [ngClass]="{ 'has-danger' : (submitted && !multiDueAmount) || !!message}">
        <label class="text-muted" for="large-rounded-input">{{'Due'|translate}} {{'Amount'|translate}}</label>
        <input type="text" class="form-control" [(ngModel)]="multiDueAmount">
        <small class="text-danger" *ngIf="submitted && !multiDueAmount">
          {{'Due'|translate}} amount {{'is required'|translate}}
        </small>
        <small class="text-danger" *ngIf="!!message ">
          {{message}}
        </small>
      </div>
    </div>    
  </div>
  <div class="row">
    <div class="col-sm-6">
      <div class="mb-3 " *ngIf="paymentData.transactionType!='CASH'"
        [ngClass]="{ 'has-danger' : (submitted && !paymentData.bankAccountId) }">
        <label class="text-muted" for="select-input">bank</label>
        <select class="form-control" [(ngModel)]="paymentData.bankAccountId">
          <option></option>
          <option value="{{bank.id}}" *ngFor="let bank of allBankList">{{bank.name}}-{{bank.accNum}}</option>
        </select>
        <small class="text-danger" *ngIf="submitted && !paymentData.bankAccountId">
          {{'Bank'|translate}} {{'is required'|translate}}
        </small>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="mb-3 " *ngIf="paymentData.transactionType==='CHEQUE' && !!paymentData.bankAccountId"
        [ngClass]="{ 'has-danger' : (submitted && !paymentData.chequeNo) }">
        <label class="text-muted" for="select-input">Cheque No</label>
        <input type="text" class="form-control" [(ngModel)]="paymentData.chequeNo">
        <small class="text-danger" *ngIf="submitted && !paymentData.chequeNo">
          Cheque {{'number'|translate}} {{'is required'|translate}}
        </small>
      </div>

      <div class="mb-3 "
        *ngIf="(paymentData.transactionType==='POS'
                ||paymentData.transactionType==='QRCODE'||paymentData.transactionType==='NETBANKING') && !!paymentData.bankAccountId"
        [ngClass]="{ 'has-danger' : (submitted && !paymentData.chequeNo) }">
        <label class="text-muted" for="select-input">Transaction No</label>
        <input type="text" class="form-control" [(ngModel)]="paymentData.chequeNo">
        <small class="text-danger" *ngIf="submitted && !paymentData.chequeNo">
          {{ 'Transaction'|translate}} {{'number'|translate}} {{'is required'|translate}}
        </small>
      </div>

    </div>
    <div class="col-sm-6"
      *ngIf="paymentData.transactionType==='CHEQUE' && !!paymentData.bankAccountId && !!paymentData.chequeNo">
      <div class="custom-control custom-checkbox" (click)="changeChequeClearance($event)">
        <input class="custom-control-input float-right" type="checkbox" id="same_address"
          [checked]="chequeCleared===true">
        <label class="custom-control-label" for="same_address">{{'cheque cleared? ' |translate}} </label>
      </div>
    </div>

    <div class="col-sm-6" *ngIf="paymentData.transactionType==='POS' && !!paymentData.bankAccountId">
      <div class="mb-3 ">
        <div class="col-3">
          <label class="text-muted">CARD Charge (%)</label>
        </div>
        <div class="col-9">
          <input type="text" class="form-control form-control-sm" [(ngModel)]="paymentData.posCharge" disabled>
        </div>
      </div>
    </div>
    <div class="col-sm-6" *ngIf="paymentData.transactionType==='POS' && !!paymentData.bankAccountId">
      <div class="mb-3 ">
        <div class="col-3">
          <label class="text-muted">Swiping Amount</label>
        </div>
        <div class="col-9">
          <input type="text" class="form-control form-control-sm" [(ngModel)]="swipingAmount" disabled>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <!-- <div class="col-sm-6">
      <div class="mb-3 " [ngClass]="{ 'has-danger' : (submitted && !paymentData.accountId) }">
        <label class="text-muted" for="large-rounded-input">{{'Account'|translate}}</label>
        <select class="form-control" [(ngModel)]="paymentData.accountId">
          <option value=""> Choose {{'Account'|translate}}</option>
          <option value="{{account.id}}" *ngFor="let account of allAccountsList">{{account.name}}</option>
        </select>
        <small class="text-danger" *ngIf="submitted && !paymentData.accountId">
          {{'Account'|translate}} {{'is required'|translate}}
        </small>
      </div>
    </div> -->
    <div class="col-sm-6">
      <div class="mb-3 " [ngClass]="{ 'has-danger' : (submitted && !paymentData.paymentDate) }">
        <label class="text-muted" for="large-rounded-input">Payment {{'Date'|translate}}</label>
        <datetime [datepicker]="datePickerOptions" [timepicker]="false" [(ngModel)]="paymentData.paymentDate">
        </datetime>
        <small class="text-danger" *ngIf="submitted && !paymentData.paymentDate">
          Payment {{'Date'|translate}} {{'is required'|translate}}
        </small>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-sm" type="button" (click)="activeModal.dismiss()">cancel</button>
  <button class="btn btn-success btn-sm" *ngIf="!array.length" type="button" (click)="addPayment()">add</button>
  <button class="btn btn-success btn-sm" *ngIf="!!array.length" type="button"
    (click)="addPaymentMultiple()">add</button>
  <br>
  <small class="text-danger" *ngIf="submitted && isNotValidPaymentDate">
    {{'Valid payment date is required'|translate}}
  </small>

</div>